export default function DocumentHero() {
  return (
    <section className="w-full bg-white pt-24 pb-0 border-b border-gray-100">
      <div className="max-w-5xl mx-auto px-6">
        <div className="py-10 flex flex-col md:flex-row md:items-center gap-6">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-4">
              <span
                className="text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full"
                style={{ backgroundColor: 'rgba(46,125,107,0.1)', color: '#2E7D6B' }}
              >
                INSURANCE CLAIM GUIDE
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 leading-snug mb-3">
              간병보험 청구{' '}
              <span style={{ color: '#2E7D6B' }}>4단계 완벽 가이드</span>
            </h1>
            <div
              className="rounded-xl px-5 py-4 text-sm leading-relaxed"
              style={{ backgroundColor: '#f0f9f6', borderLeft: '4px solid #2E7D6B' }}
            >
              <p className="text-gray-700">
                간병 시작 전 <strong>병원 사전확인</strong>부터 <strong>보험금 청구</strong>까지,{' '}
                단계별로 꼭 필요한 서류와 절차를 정리했습니다.
              </p>
              <p className="text-xs text-gray-500 mt-1">
                보험금을 받기 위해 반드시 따라야 할 프로세스입니다. 각 단계를 꼼꼼히 확인하세요.
              </p>
            </div>
          </div>
          <div className="flex-shrink-0 flex items-center justify-center">
            <div
              className="w-32 h-32 md:w-40 md:h-40 rounded-2xl flex flex-col items-center justify-center gap-2"
              style={{ backgroundColor: '#f0f9f6', border: '2px solid rgba(46,125,107,0.2)' }}
            >
              <i className="ri-guide-line text-4xl md:text-5xl" style={{ color: '#2E7D6B' }} />
              <span className="text-xs font-bold text-gray-600 text-center leading-tight px-2">청구 가이드<br />4단계</span>
            </div>
          </div>
        </div>

        {/* Quick summary badges */}
        <div className="flex flex-wrap gap-2 pb-8">
          {[
            { icon: 'ri-hospital-line', label: '1. 병원 사전확인' },
            { icon: 'ri-edit-box-line', label: '2. 간병일지 작성' },
            { icon: 'ri-money-dollar-circle-line', label: '3. 정산 및 증빙' },
            { icon: 'ri-bank-line', label: '4. 보험금 청구' },
          ].map((badge, i) => (
            <div
              key={i}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold"
              style={{ backgroundColor: 'rgba(46,125,107,0.08)', color: '#2E7D6B' }}
            >
              <i className={`${badge.icon} text-xs`} />
              {badge.label}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}